import {MessageCodes} from "../MessageCodes";
import {useAppContext} from "../../../context/AppContext";
import ResultView from "../../../components/ResultView";
import ResultText from "../ResultText";
import EmptyLine from "../EmptyLine";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultBody from "../../../components/table/ResultBody";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultCellHighlight from "../../../components/table/ResultCellHighlight";
import HecRasHelper from "../../../helpers/HecRasHelper";

const pl = (n, singular, plural) => (Math.abs(n) <= 1 ? singular : plural)

const Row = ({base, cmp}) => (
    <ResultRow>
        <ResultBodyCell style={{textAlign: 'left'}}>{base}</ResultBodyCell>
        <ResultBodyCell style={{textAlign: 'left'}}>{cmp}</ResultBodyCell>
    </ResultRow>
)

export function COV2({message_key}) {
    const {getSelectedHistory} = useAppContext()
    const summary = getSelectedHistory()?.summary
    const base = summary?.base
    const compare = summary?.compare

    const lengthLine = (s) => `${s?.length} feet (${(s?.length / 5280).toFixed(2)} miles)`

    const show = (field) => (base?.[field] > 0 || compare?.[field] > 0)

    return (
        <ResultView error_id={MessageCodes.Compare.COV02.error_id} message_key={message_key}>
            <ResultText>
                The base and comparison plans include the following geometry and flow data. The differences are highlighted in red.
            </ResultText>
            <EmptyLine/>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(35)}}>Base Plan</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(35)}}>Comparison Plan</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    <Row
                        base={lengthLine(base)}
                        cmp={<>{ResultCellHighlight(base?.length, compare?.length)} feet ({(compare?.length / 5280).toFixed(2)} miles)</>}
                    />
                    <Row
                        base={`${base?.crossSections} ${pl(base?.crossSections, 'cross section', 'cross sections')}`}
                        cmp={<>{ResultCellHighlight(base?.crossSections, compare?.crossSections)} {pl(compare?.crossSections, 'cross section', 'cross sections')}</>}
                    />
                    {show('single_bridge') && (
                        <Row
                            base={`${base?.single_bridge} ${pl(base?.single_bridge, '(single opening) bridge', '(single opening) bridges')}`}
                            cmp={<>{ResultCellHighlight(base?.single_bridge, compare?.single_bridge)} {pl(compare?.single_bridge, '(single opening) bridge', '(single opening) bridges')}</>}
                        />
                    )}
                    {show('multiple_bridge') && (
                        <Row
                            base={`${base?.multiple_bridge} multiple openings`}
                            cmp={<>{ResultCellHighlight(base?.multiple_bridge, compare?.multiple_bridge)} multiple openings</>}
                        />
                    )}
                    {show('culverts') && (
                        <Row
                            base={`${base?.culverts} ${pl(base?.culverts, 'culvert', 'culverts')}`}
                            cmp={<>{ResultCellHighlight(base?.culverts, compare?.culverts)} {pl(compare?.culverts, 'culvert', 'culverts')}</>}
                        />
                    )}
                    {show('inline') && (
                        <Row
                            base={`${base?.inline} ${pl(base?.inline, 'inline structure', 'inline structures')}`}
                            cmp={<>{ResultCellHighlight(base?.inline, compare?.inline)} {pl(compare?.inline, 'inline structure', 'inline structures')}</>}
                        />
                    )}
                    <Row
                        base={`${base?.profiles} ${pl(base?.profiles, 'profile', 'profiles')} with ${base?.flowLocations} flow change ${pl(base?.flowLocations, 'location', 'locations')}`}
                        cmp={<>
                            {ResultCellHighlight(base?.profiles, compare?.profiles)} {pl(compare?.profiles, 'profile', 'profiles')}
                            {' '}with {ResultCellHighlight(base?.flowLocations, compare?.flowLocations)} flow change {pl(compare?.flowLocations, 'location', 'locations')}
                        </>}
                    />
                </ResultBody>
            </ResultTable>
        </ResultView>
    )
}
